import { internalFetch } from '../utils/fetchHelper';
import { IAssetCategory } from './categoryService';
import { IQrCode } from './qrCodeService';

export interface IZoneDetails {
  id: number;
  name: string;
  qrCode: IQrCode;
  assetCategories: IAssetCategory[];
}

export interface IZone {
  id?: number;
  code?: string;
  name?: string;
  otherInfo?: string;
  childZones?: IZone[];
  parentId?: number;
  assetCategories?: IAssetCategory[];
}

export interface ICreateZoneRequest {
  code: string;
  name: string;
  parentId?: number;
  assetCategories?: number[];
  otherInfo?: string;
}

export interface IUpdateZoneRequest {
  code: string | undefined;
  name: string | undefined;
  parentId: number | undefined;
  assetCategories?: number[];
  otherInfo?: string;
}

export interface ICreateZoneResponse {
  zoneId: number;
}

export const getZones = async (
  abortController: AbortController,
  search?: string
): Promise<IZone[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/zones?${
      search ? `&search=${search}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const editZone = async (
  abortController: AbortController,
  zoneId: string,
  zone: IUpdateZoneRequest
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/zoneById?zoneId=${zoneId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(zone)
  );
};

export const createZone = async (
  abortController: AbortController,
  zone: ICreateZoneRequest
): Promise<ICreateZoneResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/zone`,
    'POST',
    abortController,
    JSON.stringify(zone)
  );
};

export const deleteZone = async (
  abortController: AbortController,
  zoneId: string
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/zoneById?zoneId=${zoneId}`,
    'DELETE',
    abortController
  );
};

export const getZoneDetail = async (
  abortController: AbortController,
  zoneId: string
): Promise<IZoneDetails> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/zoneById?zoneId=${zoneId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};
